export class FormValidator {
  private readonly EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  private readonly MAX_MESSAGE_LENGTH = 5000;

  validateEmail(email: string): boolean {
    return this.EMAIL_REGEX.test(email);
  }

  validateRequired(value: string): boolean {
    return value.trim().length > 0;
  }

  validateMaxLength(value: string, maxLength: number): boolean {
    return value.length <= maxLength;
  }

  getFieldError(fieldName: string, value: string): string | null {
    switch (fieldName) {
      case 'name':
        if (!this.validateRequired(value)) {
          return 'Dieses Feld ist erforderlich.';
        }
        break;
      
      case 'email':
        if (!this.validateRequired(value)) {
          return 'Dieses Feld ist erforderlich.';
        }
        if (!this.validateEmail(value)) {
          return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
        }
        break;
      
      case 'message':
        if (!this.validateRequired(value)) {
          return 'Dieses Feld ist erforderlich.';
        }
        if (!this.validateMaxLength(value, this.MAX_MESSAGE_LENGTH)) {
          return `Die Nachricht ist zu lang (max. ${this.MAX_MESSAGE_LENGTH} Zeichen).`;
        }
        break;
    }
    
    return null;
  }
}